export const translations = {
  es: {
    documentTitle: "Comunid — Conocé personas. Completá tu pasaporte.",
    description: "Conocé personas en eventos, escaneá sus badges, sacate una selfie y completá tu pasaporte de encuentros en Comunid.",
    language: "Idioma",
    navLabel: "Navegación principal",
    navIdea: "La idea",
    navExperience: "Cómo se juega",
    navCommunity: "La comunidad",
    navCta: "Empezar mi pasaporte",
    menuOpen: "Abrir menú",
    menuClose: "Cerrar menú",
    heroEyebrow: "TU COMUNIDAD ES UNA AVENTURA",
    heroTitle: "Conocé personas.",
    heroTitleAccent: "Completá tu pasaporte.",
    heroLead: "Encontrá Heroes y Builders en el evento, escaneá sus badges y sacate una selfie. Cada encuentro suma un sello y te acerca a un premio.",
    heroViewExperience: "Ver cómo se juega",
    heroSignoff: "Vení por el evento. Quedate por las personas.",
    heroImageOne: "Participantes de distintos países posan con sus banderas en Community Day Argentina",
    heroImageTwo: "Richard comparte una charla en Community Day Argentina",
    passportDescription: "Vista conceptual del pasaporte de encuentros con sellos y premios",
    passportHeading: "Mi pasaporte",
    passportBrand: "COMUNID / PASAPORTE",
    passportEvent: "COMMUNITY DAY ARGENTINA",
    passportProgress: "3 de 5 encuentros",
    passportHero: "HERO ×2",
    passportBuilder: "BUILDER",
    passportCommunity: "USER GROUP",
    passportStudent: "ESTUDIANTE",
    nextPrize: "PRÓXIMO PREMIO",
    nextPrizeCount: "5 encuentros",
    passportCaption: "VISTA CONCEPTUAL DEL PASAPORTE",
    encounterRecorded: "ENCUENTRO REGISTRADO",
    encounterMessage: "Un hola. Un sello.<br />Una historia más.",
    heroBottomOne: "PERSONAS &gt; PERFILES",
    heroBottomLink: "DESCUBRÍ CÓMO SE JUEGA ↓",
    heroBottomTwo: "HECHO PARA ENCONTRARNOS",
    introEyebrow: "LA IDEA",
    introTitle: "La mejor parte de una comunidad",
    introTitleAccent: "son las personas.",
    introLead: "Un evento puede terminar. Una conversación puede ser el comienzo de algo enorme.",
    introBody: "Comunid te invita a mirar más allá del badge: conocer qué hace cada persona, encontrar puntos en común y llevarte una historia que vale la pena recordar.",
    introLink: "Así se vive la experiencia ↗",
    showcaseEyebrow: "LO QUE NOS MUEVE",
    showcaseTitle: "La energía está",
    showcaseTitleSecond: "en todas partes",
    showcaseBody: "Cada comunidad crece cuando alguien comparte lo que sabe y abre espacio para una nueva persona.",
    galleryOneAlt: "La comunidad reunida con la bandera argentina en Community Day Argentina 2026",
    galleryOneLabel: "COMUNIDAD LATAM",
    galleryOneCaption: "Ideas que cruzan fronteras.",
    galleryTwoAlt: "Participantes sostienen juntas las banderas de Argentina y México",
    galleryTwoLabel: "UN HOLA",
    galleryTwoCaption: "Todo empieza al conocernos.",
    galleryThreeAlt: "Participantes se sacan una foto juntos durante el evento",
    galleryThreeLabel: "UN RECUERDO",
    galleryThreeCaption: "Un encuentro para guardar.",
    galleryNote: "Momentos de Community Day Argentina 2026.",
    experienceEyebrow: "CÓMO SE JUEGA",
    experienceTitle: "Cada encuentro",
    experienceTitleAccent: "deja su sello.",
    experienceLead: "Tres pasos para convertir una charla en parte de tu pasaporte.",
    stepOneAlt: "La comunidad reunida en Community Day Argentina 2026",
    stepOneTitle: "Encontrá",
    stepOneBody: "Descubrí Heroes, Builders y otras personas de la comunidad durante el evento.",
    stepTwoAlt: "Dos participantes se sacan una selfie durante el evento",
    stepTwoTitle: "Escaneá y sacate una selfie",
    stepTwoBody: "Conocé a la persona, escaneá su badge y guarden una foto juntos.",
    stepThreeAlt: "Una participante acerca su teléfono al badge de otra persona",
    stepThreeTitle: "Sumá sellos",
    stepThreeBody: "Completá misiones en tu pasaporte y acercate a nuevos premios.",
    finalEyebrow: "TU PRÓXIMA CONEXIÓN",
    finalTitle: "Tu próximo sello",
    finalTitleAccent: "empieza con un hola.",
    finalBody: "Entrá a Comunid y descubrí quién está del otro lado del badge.",
    footerTagline: "Personas que hacen comunidad.",
    footerAppLink: "Ir a la app ↗",
    footerHome: "Comunid, volver al inicio",
    footerCopyright: "© 2026 Comunid",
  },
  pt: {
    documentTitle: "Comunid — Conheça pessoas. Complete seu passaporte.",
    description: "Conheça pessoas nos eventos, escaneie seus crachás, tire uma selfie e complete seu passaporte de encontros no Comunid.",
    language: "Idioma",
    navLabel: "Navegação principal",
    navIdea: "A ideia",
    navExperience: "Como funciona",
    navCommunity: "A comunidade",
    navCta: "Começar meu passaporte",
    menuOpen: "Abrir menu",
    menuClose: "Fechar menu",
    heroEyebrow: "SUA COMUNIDADE É UMA AVENTURA",
    heroTitle: "Conheça pessoas.",
    heroTitleAccent: "Complete seu passaporte.",
    heroLead: "Encontre Heroes e Builders no evento, escaneie seus crachás e tire uma selfie. Cada encontro rende um selo e aproxima você de um prêmio.",
    heroViewExperience: "Veja como funciona",
    heroSignoff: "Venha pelo evento. Fique pelas pessoas.",
    heroImageOne: "Participantes de vários países posam com suas bandeiras no Community Day Argentina",
    heroImageTwo: "Richard apresenta uma palestra no Community Day Argentina",
    passportDescription: "Prévia conceitual do passaporte de encontros com selos e prêmios",
    passportHeading: "Meu passaporte",
    passportBrand: "COMUNID / PASSAPORTE",
    passportEvent: "COMMUNITY DAY ARGENTINA",
    passportProgress: "3 de 5 encontros",
    passportHero: "HERO ×2",
    passportBuilder: "BUILDER",
    passportCommunity: "USER GROUP",
    passportStudent: "ESTUDANTE",
    nextPrize: "PRÓXIMO PRÊMIO",
    nextPrizeCount: "5 encontros",
    passportCaption: "PRÉVIA CONCEITUAL DO PASSAPORTE",
    encounterRecorded: "ENCONTRO REGISTRADO",
    encounterMessage: "Um oi. Um selo.<br />Mais uma história.",
    heroBottomOne: "PESSOAS &gt; PERFIS",
    heroBottomLink: "DESCUBRA COMO FUNCIONA ↓",
    heroBottomTwo: "FEITO PARA NOS CONECTAR",
    introEyebrow: "A IDEIA",
    introTitle: "A melhor parte de uma comunidade",
    introTitleAccent: "são as pessoas.",
    introLead: "Um evento pode acabar. Uma conversa pode ser o começo de algo incrível.",
    introBody: "O Comunid convida você a olhar além do crachá: conhecer o que cada pessoa faz, encontrar pontos em comum e levar uma história para guardar.",
    introLink: "Veja como é a experiência ↗",
    showcaseEyebrow: "O QUE NOS MOVE",
    showcaseTitle: "A energia está",
    showcaseTitleSecond: "por toda parte",
    showcaseBody: "Uma comunidade cresce quando alguém compartilha o que sabe e abre espaço para uma nova pessoa.",
    galleryOneAlt: "A comunidade reunida com a bandeira argentina no Community Day Argentina 2026",
    galleryOneLabel: "COMUNIDADE LATAM",
    galleryOneCaption: "Ideias que cruzam fronteiras.",
    galleryTwoAlt: "Participantes seguram juntas as bandeiras da Argentina e do México",
    galleryTwoLabel: "UM OLÁ",
    galleryTwoCaption: "Tudo começa quando nos conhecemos.",
    galleryThreeAlt: "Participantes tiram uma foto juntos durante o evento",
    galleryThreeLabel: "UMA LEMBRANÇA",
    galleryThreeCaption: "Um encontro para guardar.",
    galleryNote: "Momentos do Community Day Argentina 2026.",
    experienceEyebrow: "COMO FUNCIONA",
    experienceTitle: "Cada encontro",
    experienceTitleAccent: "deixa sua marca.",
    experienceLead: "Três passos para transformar uma conversa em parte do seu passaporte.",
    stepOneAlt: "A comunidade reunida no Community Day Argentina 2026",
    stepOneTitle: "Encontre",
    stepOneBody: "Descubra Heroes, Builders e outras pessoas da comunidade durante o evento.",
    stepTwoAlt: "Duas pessoas tiram uma selfie durante o evento",
    stepTwoTitle: "Escaneie e tire uma selfie",
    stepTwoBody: "Conheça a pessoa, escaneie o crachá dela e tirem uma foto juntos.",
    stepThreeAlt: "Uma participante aproxima o celular do crachá de outra pessoa",
    stepThreeTitle: "Ganhe selos",
    stepThreeBody: "Complete missões no seu passaporte e chegue mais perto de novos prêmios.",
    finalEyebrow: "SUA PRÓXIMA CONEXÃO",
    finalTitle: "Seu próximo selo",
    finalTitleAccent: "começa com um oi.",
    finalBody: "Entre no Comunid e descubra quem está do outro lado do crachá.",
    footerTagline: "Pessoas que constroem comunidade.",
    footerAppLink: "Ir para o app ↗",
    footerHome: "Comunid, voltar ao início",
    footerCopyright: "© 2026 Comunid",
  },
  en: {
    documentTitle: "Comunid — Meet people. Complete your passport.",
    description: "Meet people at events, scan their badges, take a selfie, and complete your Comunid meetup passport.",
    language: "Language",
    navLabel: "Main navigation",
    navIdea: "The idea",
    navExperience: "How it works",
    navCommunity: "The community",
    navCta: "Start my passport",
    menuOpen: "Open menu",
    menuClose: "Close menu",
    heroEyebrow: "YOUR COMMUNITY IS AN ADVENTURE",
    heroTitle: "Meet people.",
    heroTitleAccent: "Complete your passport.",
    heroLead: "Find Heroes and Builders at the event, scan their badges, and take a selfie. Every meetup earns a stamp and brings you closer to a prize.",
    heroViewExperience: "See how it works",
    heroSignoff: "Come for the event. Stay for the people.",
    heroImageOne: "Attendees from different countries pose with their flags at Community Day Argentina",
    heroImageTwo: "Richard giving a talk at Community Day Argentina",
    passportDescription: "Concept preview of the meetup passport with stamps and prizes",
    passportHeading: "My passport",
    passportBrand: "COMUNID / PASSPORT",
    passportEvent: "COMMUNITY DAY ARGENTINA",
    passportProgress: "3 of 5 meetups",
    passportHero: "HERO ×2",
    passportBuilder: "BUILDER",
    passportCommunity: "USER GROUP",
    passportStudent: "STUDENT",
    nextPrize: "NEXT PRIZE",
    nextPrizeCount: "5 meetups",
    passportCaption: "CONCEPT PASSPORT PREVIEW",
    encounterRecorded: "MEETUP SAVED",
    encounterMessage: "A hello. A stamp.<br />One more story.",
    heroBottomOne: "PEOPLE &gt; PROFILES",
    heroBottomLink: "SEE HOW IT WORKS ↓",
    heroBottomTwo: "MADE FOR MEETING",
    introEyebrow: "THE IDEA",
    introTitle: "The best part of a community",
    introTitleAccent: "is its people.",
    introLead: "An event may end. A conversation can be the start of something big.",
    introBody: "Comunid invites you to look beyond the badge: learn what people do, find common ground, and leave with a story worth remembering.",
    introLink: "See the experience ↗",
    showcaseEyebrow: "WHAT BRINGS US TOGETHER",
    showcaseTitle: "The energy is",
    showcaseTitleSecond: "all around us",
    showcaseBody: "A community grows when someone shares what they know and makes room for someone new.",
    galleryOneAlt: "The community gathered with the Argentine flag at Community Day Argentina 2026",
    galleryOneLabel: "LATAM COMMUNITY",
    galleryOneCaption: "Ideas that cross borders.",
    galleryTwoAlt: "Attendees holding the flags of Argentina and Mexico together",
    galleryTwoLabel: "A HELLO",
    galleryTwoCaption: "It all starts when we meet.",
    galleryThreeAlt: "Attendees taking a photo together at the event",
    galleryThreeLabel: "A MEMORY",
    galleryThreeCaption: "A meetup worth remembering.",
    galleryNote: "Moments from Community Day Argentina 2026.",
    experienceEyebrow: "HOW IT WORKS",
    experienceTitle: "Every meetup",
    experienceTitleAccent: "leaves its mark.",
    experienceLead: "Three steps to make a conversation part of your passport.",
    stepOneAlt: "The community gathered at Community Day Argentina 2026",
    stepOneTitle: "Find people",
    stepOneBody: "Meet Heroes, Builders, and other members of the community at the event.",
    stepTwoAlt: "Two attendees taking a selfie at the event",
    stepTwoTitle: "Scan and take a selfie",
    stepTwoBody: "Meet someone, scan their badge, and take a photo together.",
    stepThreeAlt: "One attendee holding her phone near another person's badge",
    stepThreeTitle: "Collect stamps",
    stepThreeBody: "Complete passport missions and get closer to new prizes.",
    finalEyebrow: "YOUR NEXT CONNECTION",
    finalTitle: "Your next stamp",
    finalTitleAccent: "starts with hello.",
    finalBody: "Join Comunid and find out who’s behind the badge.",
    footerTagline: "People who build community.",
    footerAppLink: "Go to the app ↗",
    footerHome: "Comunid, back to home",
    footerCopyright: "© 2026 Comunid",
  },
};
